import React, {useState} from "react";
import {
    Box,
    Container,
    Typography,
    Grid,
    Paper,
    List,
    ListItem,
    ListItemIcon,
    ListItemText,
} from "@mui/material";
import FactoryIcon from "@mui/icons-material/Factory";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import BarChartIcon from "@mui/icons-material/BarChart";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import BusinessIcon from "@mui/icons-material/Business";
import AccountTreeIcon from "@mui/icons-material/AccountTree";
import SupportAgentIcon from "@mui/icons-material/SupportAgent";

const EngineeringPage: React.FC = () => {

    return (
        <Container maxWidth="lg" sx={{ py: 6 }}>
            {/* Заголовок */}
            <Typography variant="h4" fontWeight={700} gutterBottom>
                Машиностроение
            </Typography>
            <Typography variant="body1" color="text.secondary" sx={{ mb: 4 }}>
                Один из ключевых драйверов индустриального роста и импортозамещения в Казахстане
            </Typography>

            {/* Блок: Характеристики и направления */}
            <Paper sx={{ p: 4, mb: 4 }}>
                <Typography variant="h6" fontWeight={600} gutterBottom>
                    Характеристики и направления развития
                </Typography>
                <Grid container spacing={2}>
                    <Grid item xs={12} sm={4}>
                        <ListItem disablePadding>
                            <ListItemIcon><FactoryIcon color="primary" /></ListItemIcon>
                            <ListItemText
                                primary="Производство оборудования для нефтегаза, транспорта, АПК и энергетики"
                            />
                        </ListItem>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <ListItem disablePadding>
                            <ListItemIcon><LocationOnIcon color="primary" /></ListItemIcon>
                            <ListItemText
                                primary="Создание кластеров в Костанае, Алматы и Астане"
                            />
                        </ListItem>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <ListItem disablePadding>
                            <ListItemIcon><BarChartIcon color="primary" /></ListItemIcon>
                            <ListItemText
                                primary="Рост доли локализованной продукции с 15% до 35% за 5 лет"
                            />
                        </ListItem>
                    </Grid>
                </Grid>
            </Paper>

            {/* Блок: Ключевые показатели */}
            <Paper sx={{ p: 4, mb: 4 }}>
                <Typography variant="h6" fontWeight={600} gutterBottom>
                    Ключевые показатели отрасли (на 2024 год)
                </Typography>
                <Grid container spacing={2}>
                    {[
                        { value: "3,5 трлн ₸", label: "Объем производства" },
                        { value: "1 200+", label: "Число предприятий" },
                        { value: "182,5 тыс.", label: "Численность занятых" },
                        { value: "$2,1 млрд", label: "Экспорт" },
                        { value: "12,8 %", label: "Доля в промышленности" },
                        { value: "+17,5 %", label: "Рост за 6 лет к 2018 году" },
                    ].map((item, index) => (
                        <Grid item xs={12} sm={6} md={4} key={index}>
                            <Paper variant="outlined" sx={{ p: 2, textAlign: "center" }}>
                                <Typography variant="h6" fontWeight={700}>
                                    {item.value}
                                </Typography>
                                <Typography variant="body2" color="text.secondary">
                                    {item.label}
                                </Typography>
                            </Paper>
                        </Grid>
                    ))}
                </Grid>
            </Paper>

            {/* Блок: Инвестиции */}
            <Paper sx={{ p: 4 }}>
                <Typography variant="h6" fontWeight={600} gutterBottom>
                    Меры и потенциал для капиталовложений
                </Typography>
                <Grid container spacing={2}>
                    <Grid item xs={12} sm={6}>
                        <ListItem disablePadding>
                            <ListItemIcon><CheckCircleIcon color="primary" /></ListItemIcon>
                            <ListItemText primary="Государственная поддержка проектов с локализацией > 30%" />
                        </ListItem>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <ListItem disablePadding>
                            <ListItemIcon><BusinessIcon color="primary" /></ListItemIcon>
                            <ListItemText primary="Индустриальные зоны с налоговыми преференциями" />
                        </ListItem>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <ListItem disablePadding>
                            <ListItemIcon><AccountTreeIcon color="primary" /></ListItemIcon>
                            <ListItemText primary="Перспективы создания экспортных цепочек по машиностроению" />
                        </ListItem>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <ListItem disablePadding>
                            <ListItemIcon><SupportAgentIcon color="primary" /></ListItemIcon>
                            <ListItemText primary="Гранты и субсидии от Компания, БРК и МИНПРОМа" />
                        </ListItem>
                    </Grid>
                </Grid>
            </Paper>
        </Container>
    );
};

export default EngineeringPage;